import React from "react";

import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styled from "./ConfirmDialogBody.styles";
import identifiers from "../../../util/identifiers.json";
import Button from "../../Button/Button";
import { ModalHeader } from "../../Modal/ModalHeader/ModalHeader";
import { useBaseDialogContext } from "../BaseDialog";

export function ConfirmDialogBody({
  title,
  subtitle,
  confirmAction,
  buttonText,
  notDelete,
}: {
  title: string;
  subtitle: string;
  confirmAction: () => void;
  buttonText?: string;
  notDelete?: boolean;
}) {
  const { setOpen } = useBaseDialogContext();

  return (
    <Flex $column>
      <ModalHeader
        heading={title}
        subtitle={subtitle}
        hasSeparator={false}
      />
      <Styled.Container>
        <Styled.Button
          size="small"
          styling="outline"
          onClick={() => setOpen(false)}
          testId={identifiers["modules.master.table.modal.button.cancel"]}
        >
          Cancel
        </Styled.Button>
        <Button
          type="submit"
          size="small"
          color={!notDelete ? "red" : undefined}
          onClick={() => confirmAction()}
          testId={identifiers["modules.master.table.modal.button.delete"]}
        >
          {buttonText ? buttonText : "Delete"}
        </Button>
      </Styled.Container>
    </Flex>
  );
}
